package org.gymly.ui.admin

import androidx.compose.foundation.layout.Row
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import kotlinx.coroutines.launch
import org.gymly.data.AdminRepo
import org.gymly.theme.AdminColors

/**
 * Genera una contraseña que cumple la política; la calcula el servidor con un generador seguro.
 * Después de generar aparece "Escribir una propia", que vacía el campo ([onClear]) para escribirla a mano.
 */
@Composable
fun GeneratePasswordButton(
    value: String,
    onGenerated: (String) -> Unit,
    onClear: () -> Unit,
) {
    val scope = rememberCoroutineScope()
    var busy by remember { mutableStateOf(false) }
    var lastGenerated by remember { mutableStateOf<String?>(null) }
    Row(verticalAlignment = Alignment.CenterVertically) {
        TextButton(
            onClick = {
                if (busy) return@TextButton
                scope.launch {
                    busy = true
                    runCatching { AdminRepo.api.suggestPassword() }.onSuccess {
                        lastGenerated = it
                        onGenerated(it)
                    }
                    busy = false
                }
            },
            enabled = !busy,
        ) {
            Text("Generar contraseña", color = AdminColors.Primary)
        }
        if (value.isNotEmpty() && value == lastGenerated) {
            TextButton(
                onClick = {
                    lastGenerated = null
                    onClear()
                },
            ) {
                Text("Escribir una propia", color = AdminColors.TextMuted)
            }
        }
    }
}
